import HotelInput from "./HotelInput";

function HotelTimeRange({ item, fieldProps }) {
  return (
    <div className="grid grid-cols-2 gap-3">
      <HotelInput {...fieldProps} name={item.start} type="time" />
      <HotelInput {...fieldProps} name={item.end} type="time" />
    </div>
  );
}

export default HotelTimeRange;
